import { useState } from 'react';
import useCurrency from '../../hooks/useCurrency';
import { ASK_DEFAULT, ASK_QUESTIONS } from '../../data/askDemo';

export default function AskFab() {
  const [open, setOpen] = useState(false);
  const [answer, setAnswer] = useState(ASK_DEFAULT);
  /* An answer may be a function when it needs live figures (the pricing one),
     so it quotes whatever the visitor's IP resolved to. */
  const { symbol, price } = useCurrency();
  const resolve = (a) => (typeof a === 'function' ? a({ symbol, price }) : a);

  return (
    <>
      <button className="askfab" type="button" onClick={() => setOpen((v) => !v)}>
        <img src="/assets/mark-teamgrid.svg" alt="" />
        Ask TeamGrid
      </button>
      <div className={`askpanel${open ? ' open' : ''}`}>
        <div className="ap-h">
          <img src="/assets/mark-teamgrid.svg" alt="" />
          Ask TeamGrid — demo
        </div>
        <div className="ap-body">
          <span className="ap-a" dangerouslySetInnerHTML={{ __html: answer }} />
        </div>
        <div className="ap-qs">
          {ASK_QUESTIONS.map((item) => (
            <button
              key={item.q}
              type="button"
              className="ap-q"
              onClick={() => setAnswer(resolve(item.a))}
            >
              {item.q}
            </button>
          ))}
        </div>
      </div>
    </>
  );
}
